"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UIContent = void 0;
exports.UIContent = {
    general: {},
    ImageInput: {
        onlyFirstFileConsiderErrMsg: "This is a single image input. Only first file will be considered",
        corruptUrlErrMsg: "Image URL seems to be corrupt. Cannot render it"
    },
    VideoInput: {
        uploadError: "Unable to upload file"
    },
    Pdf: {
        uploadError: "Unable to upload file"
    },
    SimpleTable: {
        delete: 'Delete',
        duplicate: 'Duplicate',
        insertRowAfter: 'Insert Below',
        insertRowBefore: 'Insert Above',
        clearContent: 'Clear Content',
        insertColAfter: 'Insert Right',
        insertColBefore: 'Insert Left',
        addHeaderCol: 'Add Header Column',
        removeHeaderCol: 'Remove Header Column',
        addHeaderRow: 'Add Header Row',
        removeHeaderRow: 'Remove Header Row',
        stretchToFullWidth: 'Stretch to Full Width'
    }
};
